import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuizIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M7.29,6.77A5.26,5.26,0,1,0,12.55,12,5.27,5.27,0,0,0,7.29,6.77Zm2,6.48a.52.52,0,0,1-.74.74L7.29,12.77,6.08,14a.53.53,0,0,1-.75,0,.53.53,0,0,1,0-.74L6.55,12,5.33,10.82a.53.53,0,0,1,.75-.75l1.21,1.22,1.22-1.22a.53.53,0,0,1,.74,0,.53.53,0,0,1,0,.75L8,12Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.77,6.77A5.26,5.26,0,1,0,22,12,5.26,5.26,0,0,0,16.77,6.77Zm2.77,4.06-3.45,3.45a.51.51,0,0,1-.74,0l-1.88-1.87a.53.53,0,0,1,0-.75.53.53,0,0,1,.74,0l1.51,1.51,3.08-3.08a.52.52,0,1,1,.74.74Z"
  })]
}), 'QuizIcon');